module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Tabs/images/overlay-right-active.d060cc52.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Tabs/images/overlay-right-active.png
// module id = 2753
// module chunks = 11